import { render, staticRenderFns } from "./addInGame.vue?vue&type=template&id=0267e89d&"
import script from "./addInGame.vue?vue&type=script&lang=js&"
export * from "./addInGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0267e89d')) {
      api.createRecord('0267e89d', component.options)
    } else {
      api.reload('0267e89d', component.options)
    }
    module.hot.accept("./addInGame.vue?vue&type=template&id=0267e89d&", function () {
      api.rerender('0267e89d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/components/addInGame.vue"
export default component.exports